export const NEWS_NOW_DEFAULT_SLATE = 'https://media1.s-nbcnews.com/i/newscms/2020_01/3168931/video-slate-fallback_363c83282682fdd7f06de8310326584d.png';

export default {
  NEWS_NOW_DEFAULT_SLATE,
};
